import { pick } from '@shared/lib/collections'

import { useDemoShiftControlStore } from './store'
import { useSlotsTrackerApi } from '../../api/demo-slots/slots-tracker.hook'

interface ButtonFiltersClearReturn {
  name: string
  text: string
  disabled: ComputedRef<boolean>
  setClear: () => Promise<void>
}

export const useButtonFiltersClear = (): ButtonFiltersClearReturn => {
  const name = 'button_slots_tracker_filters_clear'
  const text = 'Clear filters'

  const router = useRouter()
  const demoShiftControlStore = useDemoShiftControlStore()

  const disabled = computed(() => demoShiftControlStore.isShiftControlBusy)

  const setClear = async (): Promise<void> => {
    demoShiftControlStore.setFilterReservationType(null)
    demoShiftControlStore.setFilterSlotStatus(null)
    demoShiftControlStore.setFilterSortBy(null)

    const query = pick({
      ...demoShiftControlStore.getFilterParams,
      current_page: String(demoShiftControlStore.getCurrentPage),
      per_page: String(demoShiftControlStore.getPerPage),
    })

    await router.push({ query })

    await useSlotsTrackerApi()
  }

  return {
    name,
    text,
    disabled,
    setClear,
  }
}
